import { NavLink } from "react-router-dom";
import { Page, Pagetype } from "../../../interfaces/Config";
import { getUrl } from "../../../utils/dataRetrieval";
import { UserType } from "../../../interfaces/User";

export const isStudentDashboardNavActive = (
    pages: Page[]
): Parameters<typeof NavLink>[0]["isActive"] => {
    const page = pages.find((page) => page.type === Pagetype.DASHBOARD);
    if (!page) return undefined;
    return (_, location) => {
        const url = getUrl(page, UserType.Student);
        return location.pathname.replace("/", "").startsWith(url);
    };
};
